<template>
  <div
    :style="getElementStyle"
    v-if="data && data.properties && data.properties.filed_content != 'Hide'"
  >
    <el-row align="middle">
      <el-col
        :span="showLabel && !isDefalutPosq ? 4 : data.description ? 20 : 24"
        :style="computedStyles"
      >
        <label
          class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          for="text"
          v-if="hasLabel && data.properties.filed_content != 'Hide'"
          :style="getLabelStyles"
        >
          {{ label || data.label }}
        </label>
        <span v-if="data.validations.required" style="color: red; font-weight: bold">*</span>
        <!-- <i
          class="el-icon-copy-document"
          v-if="!isView && !isDataTableField"
          @click="copyDocument"
        ></i> -->
        <span>
          <el-popover
            v-if="!isView && data.description"
            placement="top-start"
            trigger="hover"
            :content="data.description"
          >
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </span>
      </el-col>
      <el-col :span="showLabel && !isDefalutPosq ? 12 : 24">
        <div
          v-if="!isView"
          style="display: flex; align-items: start; gap: 10px; flex-direction: column"
        >
          <el-input
            v-model="formattedPrice"
            :placeholder="data.placeholder"
            :readonly="true"
            :style="getStyle"
          ></el-input>
          <span
            v-if="
              !isView &&
              data.properties?.allow_user_to_configure &&
              (!data.is_entity_variable ||
                (data.is_entity_variable && data.field_assignable !== 'read_only'))
            "
          >
            <div style="display: flex; align-items: center">
              <el-checkbox
                v-model="showSlabPrices"
                @change="handleDialogOpen"
                :style="getCheckboxStyle"
              ></el-checkbox>

              <span
                class="text-sm"
                @click="handleTextClick"
                style="margin-left: 8px; cursor: pointer; width: 200px"
                :style="getCheckboxStyle"
              >
                Configure Slab Prices
              </span>
            </div>
          </span>
          <span v-if="isActive || isDataTableField" class="setting-icon" @click="openSettings">
            <i class="el-icon-s-tools" />
          </span>
        </div>
        <div v-else>
          {{ formattedPrice }}
        </div>

        <dialog-component
          title="Configure Slab Prices"
          :visible="showSlabDialog"
          :containerMaxHeight="'60%'"
          @before-close="handleDialogClose"
        >
          <price-slabs-tabs
            ref="priceSlabs"
            :data="data"
            :field="field"
            :form="form"
            :selectedValue="selectedValue"
          />

          <template #footer>
            <el-button @click="showSlabDialog = false">Cancel</el-button>
            <el-button type="primary" @click="saveSlabChanges">Save</el-button>
          </template>
        </dialog-component>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  var currencyToSymbolMap = require('@/components/payment-link/CurrencySymbols.json');
  export default {
    components: {
      PriceSlabsTabs: () => import('../PriceSlabsTabs.vue'),
    },
    props: [
      'data',
      'label',
      'value',
      'isActive',
      'isView',
      'hasLabel',
      'isDataTableField',
      'isInDataTable',
      'labelAlignments',
      'fieldsData',
      'allFields',
      'templatesData',
      'form',
      'parentFormData',
    ],
    data() {
      return {
        showLabel: true,
        durationFieldKey: null,
        pricing_slabs: [],
        isUniform: null,
        selectedValue: this.data.key,
        thresholdPrice: null,
        showSlabPrices: false,
        showSlabDialog: false,
        slabConfig: {
          isUniform: true,
          slab_prices: [],
        },
        field: {
          price_settings: {},
        },
      };
    },
    computed: {
      computedStyles() {
        const styles = {};
        styles.display = 'flex';
        if (this.labelAlignments || this.data?.styles?.labelAlignments) {
          styles.justifyContent = this.labelAlignments || this.data?.styles?.labelAlignments;
        }
        return styles;
      },
      getLabelStyles() {
        return this.data.styles && this.data.styles.label_color
          ? `color: ${this.data.styles.label_color}; `
          : 'font-weight: 700';
      },
      getStyle() {
        let style = '';
        if (this.data.height) {
          style += ` width: 100%; min-width: 200px; `;
        }
        if (this.hasLabel) {
          style += `margin-top: 0px;`;
        } else {
          style += `margin-top: 13%;`;
        }
        style += 'font-weight: 400; ';
        if (!this.data.is_entity_variable && this.isView) {
          style += 'margin-top: 0px; width: 100%; min-width: 200px;';
        }
        if (this.data.is_entity_variable && this.data.properties?.hideLabel && this.isView) {
          style += 'margin-top: 25px; ';
        }
        return style.trim();
        // return `height:${
        //   this.data.height - 30
        // }px; width: 100%; min-width: 200px;`;
      },
      getCheckboxStyle() {
        let style = 'margin-left: 0px;';
        if (this.hasLabel) {
          style += `margin-top: 0px; margin-bottom: 0px;margin-left:5px;`;
        } else {
          style += `margin-top: 20px;`;
        }
        return style;
      },
      formattedPrice() {
        const symbol = this.getCurrencySymbol(this.data.validations.currency) || '';
        const value = this.form[this.data.key] || 0;
        return `${symbol} ${value}`;
      },
      getCurrencySymbol() {
        return (currency) => {
          return currencyToSymbolMap[currency];
        };
      },
      getElementStyle() {
        let borderStyle = '';
        if (this.data.styles) {
          const { border_type, border_size, border_color, background, label_color, font } =
            this.data.styles;
          let type = border_type || 'solid';
          let size = border_size ? border_size + 'px' : '0px';
          let color = border_color || '';
          let font_size = font?.font_size || 14;
          let bold = font?.style === 1 || font?.style === 3 ? 'bold' : '';
          let italic = font?.style === 2 || font?.style === 3 ? 'italic' : '';

          borderStyle += `border:${type} ${size} ${color};`;
          if (background) borderStyle += `background:${background};`;
          borderStyle += `font-size:${font_size}px;`;
          if (bold) borderStyle += `font-weight:${bold};`;
          if (italic) borderStyle += `font-style:${italic};`;
          if (label_color) borderStyle += `color:${label_color};`;
        }
        return borderStyle;
      },
      isDefalutPosq() {
        return !(this.data.styles && this.data.styles.labelStyle === 'right');
      },
      durationValue() {
        if (!this.isView) {
          return this.form?.[this.durationFieldKey];
        } else {
          return [];
        }
      },
      thesholdPriceValue() {
        if (!this.isView) {
          return this.form?.[this.thresholdPrice];
        } else {
          return [];
        }
      },
      dynamicSlabKey() {
        return this.form[this.data.key + '/isSlabConfig'];
      },
      fixedPriceFields() {
        return {
          hourly: this.form?.[this.hourly_price] || this.hourly_price,
          daily: this.form?.[this.daily_price] || this.daily_price,
          weekly: this.form?.[this.weekly_price] || this.weekly_price,
          monthly: this.form?.[this.monthly_price] || this.monthly_price,
          yearly: this.form?.[this.yearly_price] || this.yearly_price,
          totalDays: this.form?.[this.total_days] || this.total_days,
        };
      },
    },
    mounted() {
      this.showSlabPrices = this.form[this.data.key + '/isSlabConfig'] || false;
      if (this.data.styles?.labelStyle === 'hide') {
        this.showLabel = false;
      }
      if (this.data?.price_settings && this.data?.price_settings?.pricingType === 'step_price') {
        //this.durationFieldKey = this.data.price_settings?.durationFieldKey;
        if (this.data?.price_settings?.duration) {
          this.durationFieldKey = this.data.price_settings.duration;
        }
        if (this.data?.price_settings?.thresholdValue) {
          this.thresholdPrice = this.data.price_settings.thresholdValue;
        }
        if (this.data?.price_settings?.configMode == 'reference') {
          this.setReferenceData();
        }
        if (this.data?.price_settings?.configMode === 'configure') {
          this.pricing_slabs = this.data.price_settings?.pricingSlabs;
          this.isUniform = this.data.price_settings?.isUniform;
        }
      }
      if (this.data?.price_settings?.pricingType === 'fixed_price') {
        this.hourly_price = this.data.price_settings.hourly_price;
        this.daily_price = this.data.price_settings.daily_price;
        this.weekly_price = this.data.price_settings.weekly_price;
        this.monthly_price = this.data.price_settings.monthly_price;
        this.yearly_price = this.data.price_settings.yearly_price;
        this.total_days = this.data.price_settings.total_days;
      }
    },
    methods: {
      copyDocument() {
        this.$emit('copy-document', this.data.key);
      },
      openSettings() {
        this.$emit('settings');
      },
      async calculateTotalPrice(booking_mins, pricing_slabs, isUniform, thresholdPrice) {
        try {
          if (
            this.form[this.data.key + '/isSlabConfig'] &&
            this.form[this.data.key + '/slabConfig']
          ) {
            pricing_slabs = this.form[this.data.key + '/slabConfig'].slab_prices;
            isUniform = this.form[this.data.key + '/slabConfig'].isUniform;
          }
          if (!booking_mins) {
            this.$set(this.form, this.data.key, 0);
            return 0;
          }
          const config = isUniform
            ? {
                isUniform: true,
                totalMinutes: booking_mins,
                thresholdPrice: thresholdPrice || 0,
                steps: pricing_slabs,
              }
            : {
                isUniform: false,
                totalMinutes: booking_mins,
                thresholdPrice: thresholdPrice || 0,
                steps: pricing_slabs,
              };
          const price = await this.calculateTotalPriceforSlab(config);
          this.$set(this.form, this.data.key, price);
          return price;
        } catch (err) {
          return err;
        }
      },

      //without Threshold Price

      // async calculateTotalPriceforSlab(config) {
      //   try {
      //     const { totalMinutes, steps, isUniform } = config;
      //     let total = 0;
      //     let coveredTill = 0;

      //     const sortedSteps = [...steps].sort((a, b) => a.from - b.from);

      //     if (isUniform) {
      //       const lastStep = sortedSteps[sortedSteps.length - 1];
      //       const intervalSize = lastStep.to - lastStep.from;
      //       const lastPrice = lastStep.price;

      //       for (let step of sortedSteps) {
      //         //const stepDuration = step.to - step.from;
      //         if (coveredTill >= totalMinutes) break;

      //         const rangeStart = step.from;
      //         const rangeEnd = Math.min(step.to, totalMinutes);

      //         if (rangeStart >= totalMinutes) break;

      //         const duration = rangeEnd - rangeStart;
      //         if (duration > 0) {
      //           total += step.price;
      //           coveredTill = rangeEnd;
      //         }
      //       }

      //       // Fill remaining time using uniform intervals
      //       if (coveredTill < totalMinutes) {
      //         let remaining = totalMinutes - coveredTill;
      //         const fullIntervals = Math.floor(remaining / intervalSize);
      //         const leftover = remaining % intervalSize;

      //         total += fullIntervals * lastPrice;

      //         if (leftover > 0) {
      //           total += lastPrice; // If you charge full price for partial interval
      //           // OR, to charge proportionally: total += lastPrice * (leftover / intervalSize);
      //         }
      //       }

      //       return total;
      //     } else {
      //       // Non-uniform logic — add price only if within step range
      //       for (let step of sortedSteps) {
      //         const rangeStart = step.from;
      //         const rangeEnd = Math.min(step.to, totalMinutes);

      //         if (rangeStart >= totalMinutes) break;

      //         const duration = rangeEnd - rangeStart;
      //         if (duration > 0) {
      //           total += step.price;
      //           coveredTill = rangeEnd;
      //         }
      //       }

      //       // Optionally add last price for uncovered duration
      //       if (coveredTill < totalMinutes) {
      //         const lastPrice =
      //           sortedSteps.length > 0
      //             ? sortedSteps[sortedSteps.length - 1].price
      //             : 0;
      //         total += lastPrice;
      //       }

      //       return total;
      //     }
      //   } catch (err) {
      //     return err;
      //   }
      // },

      //with Threshold Price

      async calculateTotalPriceforSlab(config) {
        try {
          const { totalMinutes, steps, isUniform, thresholdPrice } = config;
          let total = 0;
          let coveredTill = 0;

          const sortedSteps = [...steps].sort((a, b) => a.from - b.from);
          const lastStep = sortedSteps[sortedSteps.length - 1];
          const intervalSize = lastStep?.to - lastStep?.from || 0;
          const fallbackPrice = thresholdPrice ?? lastStep?.price ?? 0;

          const applicableSteps = sortedSteps.filter((step) => step.from < totalMinutes);

          total = applicableSteps.reduce((acc, step) => {
            const rangeStart = step.from;
            const rangeEnd = Math.min(step.to, totalMinutes);
            const duration = rangeEnd - rangeStart;

            if (duration > 0) {
              coveredTill = rangeEnd;
              return acc + step.price;
            }

            return acc;
          }, 0);

          const remainingTime = totalMinutes - coveredTill;

          if (remainingTime > 0) {
            if (isUniform && intervalSize > 0) {
              const fullIntervals = Math.floor(remainingTime / intervalSize);
              const leftover = remainingTime % intervalSize;

              total += fullIntervals * fallbackPrice;

              if (leftover > 0) {
                total += fallbackPrice; // or fallbackPrice * (leftover / intervalSize) for proportional
              }
            } else {
              total += fallbackPrice;
            }
          }

          return total;
        } catch (err) {
          return err;
        }
      },
      handleTextClick() {
        if (!this.showSlabPrices) {
          this.showSlabPrices = true;
        }
        this.handleDialogOpen(this.showSlabPrices);
      },
      handleDialogOpen(checked) {
        this.$set(this.form, this.data.key + '/isSlabConfig', this.showSlabPrices);
        let thresholdPrice = this.form[this.thresholdPrice] || this.thresholdPrice;
        let durationValue = this.form[this.durationFieldKey] || this.durationFieldKey;
        this.calculateTotalPrice(
          Number(durationValue) || 0,
          this.pricing_slabs,
          this.isUniform,
          Number(thresholdPrice) || 0
        );
        if (checked) {
          this.showSlabDialog = true;
        }
      },
      handleDialogClose() {
        // Optionally reset checkbox or data
        this.showSlabDialog = false;
      },
      handleSlabUpdate(updatedValue) {
        // Handle real-time slab config change
        this.slabConfig = updatedValue;
      },
      saveSlabChanges() {
        const slabRef = this.$refs.priceSlabs;
        const isUniform = slabRef.activeName === 'uniform';
        const slabs = isUniform ? slabRef.uniform.slabs : slabRef.nonUniform.slabs;
        const isValid = slabs.every((s) => s.from != null && s.to != null && s.price != null);
        if (!isValid) {
          this.$message.error('Please fill all slab fields before saving.');
          return;
        }
        const steps = slabRef.uniform.steps || 0;
        const interval = slabRef.uniform.interval || 0;
        const activeName = slabRef.activeName || 'uniform';
        this.slabConfig = {
          isUniform,
          steps, // <- add this
          interval,
          activeName,
          slab_prices: slabs.map((slab) => ({
            from: slab.from,
            to: slab.to,
            price: slab.price,
          })),
        };
        this.showSlabDialog = false;
        this.$set(this.form, this.data.key + '/slabConfig', this.slabConfig);
        this.$set(this.form, this.data.key + '/isSlabConfig', this.showSlabPrices);
      },
      async calculateTotalPriceforFixedPrice(
        hourly_price,
        day_price,
        weekly_price,
        monthly_price,
        yearly_price,
        booking_days
      ) {
        try {
          if (!booking_days) {
            this.$set(this.form, this.data.key, 0);
            return 0;
          }

          let totalPrice = 0;

          while (booking_days > 0) {
            switch (true) {
              case booking_days >= 365: {
                const years = Math.floor(booking_days / 365);
                totalPrice += years * yearly_price;
                booking_days %= 365;
                break;
              }

              case booking_days >= 30: {
                const months = Math.floor(booking_days / 30);
                totalPrice += months * monthly_price;
                booking_days %= 30;
                break;
              }

              case booking_days >= 7: {
                const weeks = Math.floor(booking_days / 7);
                totalPrice += weeks * weekly_price;
                booking_days %= 7;
                break;
              }

              case booking_days >= 1: {
                const days = Math.floor(booking_days);
                totalPrice += days * day_price;
                booking_days -= days;
                break;
              }

              case booking_days > 0: {
                const hours = booking_days * 24; // fraction of day to hours
                totalPrice += hours * hourly_price;
                booking_days = 0;
                break;
              }
            }
          }
          totalPrice = totalPrice % 1 === 0 ? totalPrice : parseFloat(totalPrice.toFixed(2));
          this.$set(this.form, this.data.key, totalPrice);
          return totalPrice;
        } catch (err) {
          return err;
        }
      },
      async setReferenceData() {
        let referenceKey = this.data?.price_settings?.referenceField;
        this.pricing_slabs =
          this.form[`${referenceKey}/slabConfig`]?.slab_prices ||
          this.data.price_settings?.pricingSlabs;
        this.isUniform =
          this.form[`${referenceKey}/slabConfig`]?.isUniform || this.data.price_settings?.isUniform;
      },
    },
    watch: {
      async durationValue(newVal) {
        let thresholdPrice = this.form[this.thresholdPrice] || this.thresholdPrice;
        await this.calculateTotalPrice(
          newVal,
          this.pricing_slabs,
          this.isUniform,
          Number(thresholdPrice) || 0
        );
      },
      async thesholdPriceValue(newVal) {
        let durationValue = this.form[this.durationFieldKey] || this.durationFieldKey;
        await this.calculateTotalPrice(
          Number(durationValue) || 0,
          this.pricing_slabs,
          this.isUniform,
          Number(newVal)
        );
      },
      dynamicSlabKey(newVal) {
        if (newVal) {
          this.showSlabPrices = newVal;
        } else {
          this.showSlabPrices = false;
        }
      },

      fixedPriceFields: {
        deep: true,
        handler: async function (newVal) {
          if (this.data?.price_settings?.pricingType === 'fixed_price') {
            await this.calculateTotalPriceforFixedPrice(
              Number(newVal.hourly) || 0,
              Number(newVal.daily) || 0,
              Number(newVal.weekly) || 0,
              Number(newVal.monthly) || 0,
              Number(newVal.yearly) || 0,
              Number(newVal.totalDays) || 0
            );
          }
        },
      },
      form: {
        async handler() {
          if (this.data?.price_settings?.configMode === 'reference') {
            await this.setReferenceData();
          }
        },
        deep: true,
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-input-number {
    width: 100% !important;

    .el-input,
    .el-input__inner {
      height: inherit !important;
    }
  }
</style>
